export default __webpack_public_path__ + "static/media/glovo-light.2fd83a45.svg";